import React, { useState } from 'react'
import styled from 'styled-components'
import { DEVICE_MD_DOWN } from '../utils/deviceUtils'

const FilterContainer = styled.div`
  position: fixed;
  top: 1rem;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zindex.overlay};
  text-align: center;

  @media ${DEVICE_MD_DOWN} {
    display: flex;
    overflow-x: auto;
  }
`

const PillButton = styled.button`
  border: none;
  box-shadow: ${({ theme }) => theme.defaultBoxShadow};
  padding: 0.25rem;
  margin: 0.25rem;
  background-color: ${({ selected, theme }) => (selected ? theme.colors.primary : 'white')};
  border-radius: 3px;
  white-space: nowrap;
`

const FilterPill = ({ id, name, onClick, initialSelected }) => {
  const [isSelected, setIsSelected] = useState(initialSelected)

  const handleClick = () => {
    onClick(id)
    setIsSelected(!isSelected)
  }

  return (
    <PillButton title={`Knop om ${name} te filteren`} onClick={handleClick} selected={isSelected}>
      {name}
    </PillButton>
  )
}

const PoiFilters = ({ baseMap, poiLayers }) => {
  const handleClick = (target) => {
    const layer = poiLayers.filter((poiLayer) => poiLayer.id === target)[0]
    layer.dataLayer.setMap(layer.dataLayer.getMap() ? null : baseMap)
  }

  return (
    <FilterContainer>
      {poiLayers.map((poi) => (
        <FilterPill
          key={poi.id}
          id={poi.id}
          name={poi.name}
          onClick={handleClick}
          initialSelected={poi.initialSelected}
        />
      ))}
    </FilterContainer>
  )
}

export default PoiFilters
